export const GET_PERSON = '/person/';
export const GET_PERSON_BY_ID = id => `/person/${id}/`;
export const PATCH_PERSON = id => `/person/${id}/`;
export const PATCH_PERSON_BUDGET = (id, budget_kind) =>
  `/person/${id}/budgets/${budget_kind}/`;
export const CURRENT_PERSON = '/person/current';
export const DELETE_PERSON_BY_SCHEDULING = id =>
  `/person/${id}/working_day_schedule/`;
